import React from 'react';
import { Link as ButtonLink } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function TranslationButton({ loading, translated, onClick }: any) {
  const buttonText = translated ? 'TRANSLATION.REVERSE_TRANSLATE' : 'TRANSLATION.TRANSLATE';

  return (
    <ButtonLink component="button" onClick={onClick} variant="body1" underline="hover">
      <strong>
        <FormattedMessage id={loading ? 'TRANSLATION.TRANSLATING' : buttonText} />
      </strong>
    </ButtonLink>
  );
}

export default TranslationButton;
